const NOTIFICATION_TYPE_TITLE_KEYS = {
    invoice_notify:             'notif_title_invoice_notify',
    invoice_modified:           'notif_title_invoice_modified',
    invoice_create_failed:      'notif_title_invoice_create_failed',
    invoice_reserve:            'notif_title_invoice_reserve',
    invoice_media:              'notif_title_invoice_media',
    invoice:                    'notif_title_invoice',
    courier_registration:       'notif_title_courier_registration',
    courier_registration_error: 'notif_title_courier_registration_error',
    onboarding:                 'notif_title_onboarding',
    manager_message:            'notif_title_manager_message',
    pretense_action:            'notif_title_pretense_action',
    template_action:            'notif_title_template_action',
    error_resolve:              'notif_title_error_resolve',
    lathing_action:             'notif_title_lathing_action',
    feedback_action:            'notif_title_feedback_action',
    print_form_failed:          'notif_title_print_form_failed',
    barcode:                    'notif_title_barcode',
    media:                      'notif_title_media',
};

const NOTIFICATION_TYPE_TEXT_KEYS = {
    onboarding:      'notif_text_onboarding',
    template_action: 'notif_text_template_action',
};

export function getNotificationTitle(type, fallback, t) {
    const key = NOTIFICATION_TYPE_TITLE_KEYS[type];
    return key ? t(key) : (fallback || '—');
}

export function getNotificationText(type, fallback, t) {
    const key = NOTIFICATION_TYPE_TEXT_KEYS[type];
    if (!key) return fallback || '—';
    if (type === 'template_action') {
        const ruMatch = fallback?.match(/^Шаблон (.+) создан$/);
        const enMatch = fallback?.match(/^Template (.+) has been created$/);
        const templateName = ruMatch?.[1] ?? enMatch?.[1] ?? fallback;
        return t(key, { template_name: templateName });
    }
    return t(key);
}
